/*
 * Etats vides et de chargement de la page bilan.
 * SessionMissingView : aucune session active (conservation nulle).
 * BilanLoadingView : calcul local du bilan en cours.
 */

import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const SessionMissingView = () => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <main className="flex-1 flex items-center justify-center px-4">
      <div className="text-center max-w-[420px]">
        <h1 className="font-heading text-xl font-semibold text-[#060606]">Aucun bilan dans cette session</h1>
        <p className="mt-2 text-sm leading-relaxed text-[#333333]">
          Ton bilan existe uniquement pendant ta session active. Cette session ne contient
          aucun diagnostic terminé : tu peux refaire ton diagnostic en quelques minutes.
        </p>
        <Link to="/">
          <Button className="mt-6 rounded-xl bg-[#235277] hover:bg-[#1E4767] font-heading font-semibold" data-testid="bilan-empty-home-button">
            Refaire mon diagnostic
          </Button>
        </Link>
      </div>
    </main>
    <Footer />
  </div>
);

export const BilanLoadingView = () => (
  <div className="min-h-screen">
    <Header />
    <div className="max-w-[720px] mx-auto px-4 pt-10 space-y-6">
      <Skeleton className="h-40 w-full rounded-2xl" />
      <Skeleton className="h-72 w-full rounded-2xl" />
      <p className="text-sm text-center text-[#9E9E9E]">Génération de ton bilan…</p>
    </div>
  </div>
);
